import UserActions from "../Types";
import Storage from "../../utils/storage";
import responseHandler from "../../utils/responseHandler";
import { clearVerifyEmailState, uploadReset } from "./SingleUserActions";
import { clearDocsState } from "./GetDocsActions";
import Instance from "../../utils/api";

import jwt_decode from "jwt-decode";
import routeUser from "../../utils/Functions/RouteUser";
import { removeStorageItems } from "../../components/PrivateRoutes/removeStorageItems";


// SET CURRENT USER
export const setCurrentUser = () => ({
  type: UserActions.SET_CURRENT_USER,
});

// LOG IN USER
export const UserLoginStart = () => ({
  type: UserActions.USER_LOGIN_START,
});

export const UserLoginSuccess = (payload) => ({
  type: UserActions.USER_LOGIN_SUCCESS,
  payload,
});

export const UserLoginFailure = (payload) => ({
  type: UserActions.USER_LOGIN_FAILURE,
  payload,
});

// AUTHENTICATE USER
export const AuthenticateUserStart = () => ({
  type: UserActions.AUTHENTICATE_USER_START,
});

export const AuthenticateUserSuccess = (payload) => ({
  type: UserActions.AUTHENTICATE_USER_SUCCESS,
  payload,
});

export const AuthenticateUserFailure = (payload) => ({
  type: UserActions.AUTHENTICATE_USER_FAILURE,
  payload,
});

// LOG OUT CURRENT USER
export const logOutStart = () => ({
  type: UserActions.USER_LOG_OUT_START,
});

export const logOutSuccess = (payload) => ({
  type: UserActions.USER_LOG_OUT_SUCCESS,
  payload,
});

export const logOutFailure = (payload) => ({
  type: UserActions.USER_LOG_OUT_FAILURE,
  payload,
});

export const keepSession = () => ({
  type: UserActions.USER_LOG_OUT_SUCCESS,
});



export const userLogin = (payload, history) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(UserLoginStart());
  API.post("auth/login", payload.val).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(UserLoginSuccess(data && data.data));
      let userAuth = data && data.data && data.data.two_factor_auth;
  
      if (userAuth === false) {
        Storage.set("current-user", JSON.stringify(data.data));
        Storage.set("user-access-token", data.data.token);
        Storage.set("user-access-data", JSON.stringify(data.data.user));
        Storage.set("user-access-refresh-token", data.data.refresh_token);
        const decoded = jwt_decode(data.data.token);
        Storage.set("decoded-data", JSON.stringify(decoded));
    
        routeUser(history);
      } else {
        history.push("/authenticate");
      }
    } else {
      dispatch(UserLoginFailure(data));
    }
  });
};

export const authenticateUser = (payload, history) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(AuthenticateUserStart());
  API.post("auth/account/verify", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(AuthenticateUserSuccess(data.data));
      dispatch(clearVerifyEmailState());
      Storage.set("current-user", JSON.stringify(data.data));
      Storage.set("user-access-token", data.data.token);
      Storage.set("user-access-data", JSON.stringify(data.data.user));
      Storage.set("user-access-refresh-token", data.data.refresh_token);
      const decoded = jwt_decode(data.data.token);
      Storage.set("decoded-data", JSON.stringify(decoded));
      routeUser(history);
    } else {
      dispatch(AuthenticateUserFailure(data));
    }
  });
};

export const logOut = (payload, history) => (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(logOutStart());
  API.post("auth/token/blacklist", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(uploadReset());
      dispatch(clearDocsState());
      removeStorageItems();
      dispatch(logOutSuccess(data));
    } else {
      removeStorageItems();
      history.push("/login");
      dispatch(logOutFailure(data));
    }
  });
};




